import { Button } from "../../../components/ui/button";

const CLIENT_ID = "86x5lo08wq4hgz";
const REDIRECT_URI = "https://www.dproz.com"; // Backend endpoint

function LinkedInLogin() {
	function handleLogin() {
		const state = Math.random().toString(36).substring(7); // Random state for security
		const scope = "openid profile email"; // Request basic profile + email

		const linkedInAuthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
			REDIRECT_URI,
		)}&scope=${encodeURIComponent(scope)}&state=${state}`;

		const a = document.createElement("a");
		a.href = linkedInAuthURL;
		a.target = "_blank";
		a.click();
	}

	return (
		<Button
			type="button"
			className="w-full gap-3 whitespace-nowrap bg-[#0077B5] text-white hover:bg-[#00669c] active:bg-[#005a8a]"
			onClick={handleLogin}
		>
			<i className="fa-brands fa-linkedin text-xl text-white" aria-hidden="true" /> Continue with LinkedIn
		</Button>
	);
}

export default LinkedInLogin;
